function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
  e.setAttribute("role", "button"),
    e.setAttribute("aria-expanded", "false"),
    e.nextElementSibling.getAttribute("id") &&
      e.setAttribute("aria-controls", e.nextElementSibling.id),
    e.addEventListener("click", (e) => {
      e.currentTarget.setAttribute(
        "aria-expanded",
        !e.currentTarget.closest("details").hasAttribute("open")
      );
    }),
    e.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
  var i = getFocusableElements(e),
    s = i[0],
    r = i[i.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      (t.target === e || t.target === r || t.target === s) &&
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (t) {
      "TAB" === t.code.toUpperCase() &&
        (t.target !== r || t.shiftKey || (t.preventDefault(), s.focus()),
        (t.target === e || t.target === s) &&
          t.shiftKey &&
          (t.preventDefault(), r.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    t.focus();
}
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  let e = [
      "ARROWUP",
      "ARROWDOWN",
      "ARROWLEFT",
      "ARROWRIGHT",
      "TAB",
      "ENTER",
      "SPACE",
      "ESCAPE",
      "HOME",
      "END",
      "PAGEUP",
      "PAGEDOWN",
    ],
    t = null,
    i = null;
  window.addEventListener("keydown", (t) => {
    e.includes(t.code.toUpperCase()) && (i = !1);
  }),
    window.addEventListener("mousedown", (e) => {
      i = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        t && t.classList.remove("focused"),
          i || (t = document.activeElement).classList.add("focused");
      },
      !0
    );
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((e) => e.pause()),
    document.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
}
function removeTrapFocus(e = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && e.focus();
}
function onKeyUpEscape(e) {
  if ("ESCAPE" !== e.code.toUpperCase()) return;
  let t = e.target.closest("details[open]");
  if (!t) return;
  let i = t.querySelector("summary");
  t.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  onButtonClick(e) {
    e.preventDefault();
    let t = this.input.value;
    "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
}
function debounce(e, t) {
  let i;
  return (...s) => {
    clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
  };
}
function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${e}` },
  };
}
customElements.define("quantity-input", QuantityInput),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
      var r = e.options[i];
      if (t == r.value || t == r.innerHTML) return (e.selectedIndex = i), i;
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e.addEventListener
      ? e.addEventListener(t, i, !1)
      : e.attachEvent("on" + t, i);
  }),
  (Shopify.postLink = function (e, t) {
    var i = (t = t || {}).method || "post",
      s = t.parameters || {},
      r = document.createElement("form");
    for (var n in (r.setAttribute("method", i),
    r.setAttribute("action", e),
    s)) {
      var a = document.createElement("input");
      a.setAttribute("type", "hidden"),
        a.setAttribute("name", n),
        a.setAttribute("value", s[n]),
        r.appendChild(a);
    }
    document.body.appendChild(r), r.submit(), document.body.removeChild(r);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(i.hideElement || t)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = this.countryEl.options[this.countryEl.selectedIndex],
        i = JSON.parse(t.getAttribute("data-provinces"));
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var s = 0; s < i.length; s++) {
          var t = document.createElement("option");
          (t.value = i[s][0]),
            (t.innerHTML = i[s][1]),
            this.provinceEl.appendChild(t);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      for (var i = 0; i < t.length; i++) {
        var s = document.createElement("option");
        (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
      }
      t.length;
    },
  });
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      "iPhone" === navigator.platform &&
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        ),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((e) =>
      e.addEventListener("click", this.onSummaryClick.bind(this))
    ),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
  }
  onKeyUp(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    let t = e.target.closest("details[open]");
    t &&
      (t === this.mainDetailsToggle
        ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
        : this.closeSubmenu(t));
  }
  onSummaryClick(e) {
    let t = e.currentTarget,
      i = t.parentNode,
      s = i.hasAttribute("open");
    i === this.mainDetailsToggle
      ? (s && e.preventDefault(),
        s ? this.closeMenuDrawer(t) : this.openMenuDrawer(t))
      : (trapFocus(t.nextElementSibling, i.querySelector("button")),
        setTimeout(() => {
          i.classList.add("menu-opening"), t.setAttribute("aria-expanded", !0);
        }));
  }
  openMenuDrawer(e) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
      this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
        e.removeAttribute("open"), e.classList.remove("menu-opening");
      }),
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", !1),
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      ),
      removeTrapFocus(t),
      this.closeAnimation(this.mainDetailsToggle));
  }
  onFocusOut(e) {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(e) {
    let t = e.currentTarget.closest("details");
    this.closeSubmenu(t);
  }
  closeSubmenu(e) {
    e.classList.remove("menu-opening"),
      e.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(),
      this.closeAnimation(e);
  }
  closeAnimation(e) {
    let t,
      i = (s) => {
        void 0 === t && (t = s);
        let r = s - t;
        r < 400
          ? window.requestAnimationFrame(i)
          : (e.removeAttribute("open"),
            e.closest("details[open]") &&
              trapFocus(
                e.closest("details[open]"),
                e.querySelector("summary")
              ));
      };
    window.requestAnimationFrame(i);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(e) {
    (this.header =
      this.header || document.getElementById("shopify-section-header")),
      (this.borderOffset =
        this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      ),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this)
      ),
      this.addEventListener("keyup", (e) => {
        "ESCAPE" === e.code.toUpperCase() && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (e) => {
            "mouse" !== e.pointerType ||
              e.target.closest("deferred-media, product-model") ||
              this.hide();
          })
        : this.addEventListener("click", (e) => {
            "MODAL-DIALOG" === e.target.nodeName && this.hide();
          });
  }
  show(e) {
    this.openedBy = e;
    let t = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      t && t.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden"),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector("button");
    e?.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal"))?.show(e);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class IshiModalDialog extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this)
      ),
      this.addEventListener("click", (e) => {
        "ISHIMODAL-DIALOG" === e.target.nodeName && this.hide();
      }),
      this.addEventListener("keyup", () => {
        "ESCAPE" === event.code.toUpperCase() && this.hide();
      });
  }
  show(e) {
    this.openedBy = e;
    let t = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      this.classList.add("active"),
      document.querySelector(".newsletter-popup-overlay") &&
        document
          .querySelector(".newsletter-popup-overlay")
          .classList.add("active"),
      t && t.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden"),
      this.removeAttribute("open"),
      this.classList.remove("active"),
      document.querySelector(".newsletter-popup-overlay") &&
        document
          .querySelector(".newsletter-popup-overlay")
          .classList.remove("active"),
      this.openedBy.setAttribute("aria-expanded", "false"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia(),
      "PopupModal-newsletter" == this.getAttribute("id") &&
        !0 == $(".dono-show-check").prop("checked") &&
        setTheCookie("customer_posted", "true", 14);
  }
}
customElements.define("ishimodal-dialog", IshiModalDialog);
class IshiModalOpener extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector(".ishi-popup-modal__button");
    if (!e) return;
    e.addEventListener("click", () => {
      let t = document.querySelector(this.getAttribute("data-modal"));
      t && t.show(e);
    });
  }
}
customElements.define("ishimodal-opener", IshiModalOpener);
class QuickviewDialog extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this)
      ),
      this.addEventListener("click", (e) => {
        "QUICKVIEW-DIALOG" === e.target.nodeName && this.hide();
      }),
      this.addEventListener("keyup", () => {
        "ESCAPE" === event.code.toUpperCase() && this.hide();
      });
  }
  show(e) {
    this.openedBy = e;
    let t = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      this.classList.add("active"),
      t && t.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden"),
      this.removeAttribute("open"),
      this.classList.remove("active"),
      this.querySelector(".qv-wrapper").classList.add("loading"),
      this.openedBy.setAttribute("aria-expanded", "false"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia();
  }
}
customElements.define("quickview-dialog", QuickviewDialog);
class QuickviewOpener extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector(".product-popup-modal__button");
    e?.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal"))?.show(e);
    });
    e?.addEventListener("keydown", (t) => {
      if (t.key === "Enter" || t.key === " ") {
        t.preventDefault();
        e.click();
      }
    });
  }
}
customElements.define("quickview-opener", QuickviewOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector('[id^="Deferred-Poster-"]');
    if (!e) return;
    e.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent() {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
      let e = document.createElement("div");
      e.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0)
      ),
        this.setAttribute("loaded", !0),
        this.appendChild(
          e.querySelector("video, model-viewer, iframe")
        ).focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector("ul")),
      (this.sliderItems = this.querySelectorAll("li")),
      (this.pageCount = this.querySelector(".slider-counter--current")),
      (this.pageTotal = this.querySelector(".slider-counter--total")),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      !this.slider || !this.nextButton)
    )
      return;
    let e = new ResizeObserver((e) => this.initPages());
    e.observe(this.slider),
      this.slider.addEventListener("scroll", this.update.bind(this)),
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }
  initPages() {
    this.sliderItems.length,
      (this.slidesPerPage = Math.floor(
        this.slider.clientWidth / this.sliderItems[0].clientWidth
      )),
      (this.totalPages = this.sliderItems.length - this.slidesPerPage + 1),
      this.update();
  }
  update() {
    this.pageCount &&
      this.pageTotal &&
      ((this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) +
        1),
      1 === this.currentPage
        ? this.prevButton.setAttribute("disabled", "disabled")
        : this.prevButton.removeAttribute("disabled"),
      this.currentPage === this.totalPages
        ? this.nextButton.setAttribute("disabled", "disabled")
        : this.nextButton.removeAttribute("disabled"),
      (this.pageCount.textContent = this.currentPage),
      (this.pageTotal.textContent = this.totalPages));
  }
  onButtonClick(e) {
    e.preventDefault();
    let t =
      "next" === e.currentTarget.name
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({ left: t });
  }
}
customElements.define("slider-component", SliderComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, "", !1),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateURL(),
          this.updateVariantInput(),
          this.renderProductInfo(),
          this.doIshiTasks())
        : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (e) => e.value);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
    );
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    let e = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    e &&
      ((document.getElementById("main-media-container").innerHTML = ""),
      document.getElementById("main-media-container").prepend(e.cloneNode(!0)));
  }
  updateURL() {
    this.currentVariant &&
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateVariantInput() {
    let e = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    e.forEach((e) => {
      let t = e.querySelector('input[name="id"]');
      (t.value = this.currentVariant.id),
        t.dispatchEvent(new Event("change", { bubbles: !0 }));
    });
  }
  updatePickupAvailability() {
    let e = document.querySelector("pickup-availability");
    e &&
      (this.currentVariant?.available
        ? e.fetchAvailability(this.currentVariant.id)
        : (e.removeAttribute("available"), (e.innerHTML = "")));
  }
  removeErrorMessage() {
    let e = this.closest("section");
    if (!e) return;
    let t = e.querySelector("product-form");
    t && t.handleErrorMessage();
  }
  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((e) => e.text())
      .then((e) => {
        let t = `price-${this.dataset.section}`,
          i = new DOMParser().parseFromString(e, "text/html"),
          s = document.getElementById(t),
          r = i.getElementById(t);
        r && s && (s.innerHTML = r.innerHTML),
          document
            .getElementById(`price-${this.dataset.section}`)
            ?.classList.remove("visibility-hidden"),
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
      });
  }
  toggleAddButton(e = !0, t, i = !0) {
    let s = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (
      s &&
      (e
        ? (s.setAttribute("disabled", "disabled"), t && (s.textContent = t))
        : (s.removeAttribute("disabled"),
          (s.textContent = window.variantStrings.addToCart)),
      !i)
    )
      return;
  }
  setUnavailable() {
    let e = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    e &&
      ((e.textContent = window.variantStrings.unavailable),
      document
        .getElementById(`price-${this.dataset.section}`)
        ?.classList.add("visibility-hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
  doIshiTasks() {
    var e = this.currentVariant,
      t = document.querySelector(".variant-sku");
    if (
      (void 0 !== t &&
        null != t &&
        (document.querySelector(".variant-sku").innerHTML = e.sku),
      document.getElementsByClassName("ishi-progress-content").length)
    ) {
      var i = 0,
        s = document.getElementById("variant-" + e.id);
      void 0 !== s && null != s && (i = parseInt(s.getAttribute("data-stock")));
      var r = parseInt(
        document
          .getElementsByClassName("ishi-progress-content")[0]
          .getAttribute("data-quantity")
      );
      if (
        ((document.getElementById("variant-stock").innerHTML = i),
        i > 0 && i <= r)
      ) {
        document
          .getElementsByClassName("ishi-progress-content")[0]
          .classList.remove("hidden");
        var n = document
          .getElementById("ishi-progress-bar")
          .getElementsByTagName("span")[0];
        switch (i) {
          case 9:
            n.style.width = "65%";
            break;
          case 8:
            n.style.width = "60%";
            break;
          case 7:
            n.style.width = "55%";
            break;
          case 6:
            n.style.width = "50%";
            break;
          case 5:
            n.style.width = "45%";
            break;
          case 4:
            n.style.width = "30%";
            break;
          case 3:
            n.style.width = "20%";
            break;
          case 2:
            n.style.width = "10%";
            break;
          case 1:
            n.style.width = "5%";
            break;
          default:
            n.style.width = "90%";
        }
      } else
        document
          .getElementsByClassName("ishi-progress-content")[0]
          .classList.add("hidden");
    }
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  updateOptions() {
    let e = Array.from(this.querySelectorAll("fieldset"));
    this.options = e.map(
      (e) =>
        Array.from(e.querySelectorAll("input")).find((e) => e.checked).value
    );
  }
}
function setTheCookie(e, t, i) {
  var s = "";
  if (i) {
    var r = new Date();
    r.setTime(r.getTime() + 864e5 * i), (s = "; expires=" + r.toUTCString());
  }
  document.cookie = e + "=" + (t || "") + s + "; path=/";
}
function getTheCookie(e) {
  for (
    var t = e + "=", i = document.cookie.split(";"), s = 0;
    s < i.length;
    s++
  ) {
    for (var r = i[s]; " " == r.charAt(0); ) r = r.substring(1, r.length);
    if (0 == r.indexOf(t)) return r.substring(t.length, r.length);
  }
  return null;
}
function eraseTheCookie(e) {
  document.cookie = e + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
function setupWishlistButtons() {
  if (
    null != getTheCookie("wishlist") &&
    "__" != getTheCookie("wishlist") &&
    "" != getTheCookie("wishlist")
  )
    for (
      var e = String(getTheCookie("wishlist")).split("__"), t = 0;
      t < e.length;
      t++
    )
      "" != e[t] &&
        (null != document.querySelector(".added-wishbutton-" + e[t]) &&
          (document.querySelector(".added-wishbutton-" + e[t]).style.display =
            "block"),
        null != document.querySelector(".default-wishbutton-" + e[t]) &&
          document.querySelector(".default-wishbutton-" + e[t]).remove(),
        null != document.querySelector(".loadding-wishbutton-" + e[t]) &&
          document.querySelector(".loadding-wishbutton-" + e[t]).remove());
}
function setGridLayout() {
  if (document.querySelectorAll("#ProductGridContainer").length) {
    // Default view unless the visitor picked one on this page (see shop.js); no longer remembered across pages.
    var e = window.tgGridChoice;
    document.querySelectorAll("[data-id='" + e + "']").length ||
      (e = document
        .querySelector(".collectiongrid-layout.grid-layout-default")
        .getAttribute("data-id"));
    document.querySelectorAll(".collectiongrid-layout").forEach((e) => {
      e.classList.remove("active");
    });
    var t = document.querySelector("[data-id='" + e + "']").classList;
    (document.querySelector("[data-id=" + e + "]").classList = t + " active"),
      document
        .getElementById("product-grid")
        .querySelectorAll("li")
        .forEach((t) => {
          t.className = document
            .querySelector("[data-id=" + e + "]")
            .getAttribute("data-class");
        }),
      document.querySelector("#shopify-section-Ishi_sidebar") &&
        (e += " with-sidebar"),
      (document.getElementById("ProductGridContainer").className = e);
  }
}
function addToCartJS(e, t, i) {
  var s = new XMLHttpRequest();
  s.open("POST", "/cart/add.js", !0),
    s.setRequestHeader("Content-Type", "application/json"),
    (s.onreadystatechange = function () {
      if (4 === s.readyState && 200 === s.status) {
        var e = JSON.parse(s.responseText);
        document.querySelector(".ajax-cart-disabled") &&
          (window.location = "/cart"),
          document.querySelector("cart-notification").renderContents(e),
          i.classList.remove("loading"),
          openCartDrawer();
      }
    });
  var r = JSON.stringify({
    quantity: e,
    id: t,
    sections: [
      "cart-notification-product",
      "cart-notification-button",
      "cart-icon-bubble",
    ],
    sections_url: window.location.pathname,
  });
  s.send(r);
}
function removeFromCartJS(e) {
  var t = new XMLHttpRequest();
  t.open("POST", "/cart/change.js", !0),
    t.setRequestHeader("Content-Type", "application/json"),
    (t.onreadystatechange = function () {
      if (4 === t.readyState && 200 === t.status) {
        var e = JSON.parse(t.responseText);
        document.querySelector(".ajax-cart-disabled") &&
          (window.location = "/cart"),
          document.querySelector("cart-notification").renderContents(e);
      }
    });
  var i = JSON.stringify({
    quantity: 0,
    id: e,
    sections: [
      "cart-notification-product",
      "cart-notification-button",
      "cart-icon-bubble",
    ],
    sections_url: window.location.pathname,
  });
  t.send(i);
}
function updateCartItemJS(e, t) {
  var i = new XMLHttpRequest();
  i.open("POST", "/cart/change.js", !0),
    i.setRequestHeader("Content-Type", "application/json"),
    (i.onreadystatechange = function () {
      if (4 === i.readyState && 200 === i.status) {
        var e = JSON.parse(i.responseText);
        document.querySelector(".ajax-cart-disabled") &&
          (window.location = "/cart"),
          document.querySelector("cart-notification").renderContents(e);
      }
    });
  var s = JSON.stringify({
    quantity: e,
    id: t,
    sections: [
      "cart-notification-product",
      "cart-notification-button",
      "cart-icon-bubble",
    ],
    sections_url: window.location.pathname,
  });
  i.send(s);
}
function convertToMoney(e) {
  var e = parseFloat(e / 100).toFixed(2);
  return document.getElementsByTagName("html")[0].getAttribute("currency") + e;
}
function setCountDownTimer(e, t) {
  var i = e.split(/[- :]/),
    s = new Date(i[0], i[1] - 1, i[2], i[3], i[4], i[5]),
    r = new Date(s);
  setInterval(function () {
    var e = new Date().getTime(),
      i = r - e,
      s = Math.floor(i / 864e5),
      n = Math.floor((i % 864e5) / 36e5),
      a = Math.floor((i % 36e5) / 6e4),
      o = Math.floor((i % 6e4) / 1e3);
    (t.getElementsByClassName("countdown-days")[0].innerHTML =
      s < 10 ? "0" + s : s),
      (t.getElementsByClassName("countdown-hours")[0].innerHTML =
        n < 10 ? "0" + n : n),
      (t.getElementsByClassName("countdown-minutes")[0].innerHTML =
        a < 10 ? "0" + a : a),
      (t.getElementsByClassName("countdown-seconds")[0].innerHTML =
        o < 10 ? "0" + o : o);
  }, 1e3);
}
function openCartDrawer() {
  document.querySelector(".cart-notification").classList.add("active"),
    document.querySelector(".cart-overlay").classList.add("active"),
    document.body.classList.add("cart-overflow");
}
function closeCartDrawer() {
  document.querySelector(".cart-notification").classList.remove("active"),
    document.querySelector(".cart-overlay").classList.remove("active"),
    document.body.classList.remove("cart-overflow");
}
customElements.define("variant-radios", VariantRadios);

// // Collection page filter JS (Alvy - 09/02/2026)
// document.addEventListener("DOMContentLoaded", function () {
//   const summaries = document.querySelectorAll(".facets__summary");

//   // 👉 Open the first filter by default
//   if (summaries.length > 0) {
//     const firstDisclosure = summaries[0].closest(".facets__disclosure");
//     const firstDisplay = firstDisclosure.querySelector(".facets__displays");
//     firstDisplay.classList.add("is-open");
//   }

//   summaries.forEach((summary) => {
//     summary.addEventListener("click", function () {
//       const currentDisclosure = summary.closest(".facets__disclosure");
//       const currentDisplay = currentDisclosure.querySelector(".facets__displays");

//       // Close all other filters
//       document.querySelectorAll(".facets__displays").forEach((display) => {
//         if (display !== currentDisplay) {
//           display.classList.remove("is-open");
//         }
//       });

//       // Toggle current one
//       currentDisplay.classList.toggle("is-open");
//     });
//   });
// });


document.addEventListener("click", function (e) {
    if (e.target.closest(".mobileSearchView")) {
        e.preventDefault();
        document.querySelector(".mobilesearchArea")?.classList.toggle("active");
    }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("#_mobile_top_menu #top-menu .category").forEach(function (item) {
    
    item.addEventListener("click", function (e) {

      // prevent link navigation if needed
      if (e.target.tagName.toLowerCase() === "a") {
        e.preventDefault();
      }

      let submenu = item.querySelector(".sub-menu");
      
      if (submenu) {
        // toggle display
        if (submenu.style.display === "block") {
          submenu.style.display = "none";
        } else {
          submenu.style.display = "block";
        }
      }

    });

  });
});

// Upsell Items
document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".cartPageSwiper", {
    slidesPerView: 1,
    spaceBetween: 15,

    loop: true,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    autoplay: {
      delay: 2500, // 2.5 seconds
      disableOnInteraction: false, // keeps autoplay after swipe
      pauseOnMouseEnter: true // pause on hover (desktop)
    }, 

    speed: 600, // smooth transition speed

    breakpoints: {
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      },
    }
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   new Swiper(".cartDrawerSwiper", {
//     slidesPerView: 2,
//     spaceBetween: 15,

//     loop: true,

//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },

//     speed: 600, // smooth transition speed
//   });
// });

// document.addEventListener('click', function(e) {
//   const btn = e.target.closest(
//     '.add-to-cart-js, #qv-add-to-cart, .bundle-add-to-cart, .bundle-add-to-cart2'
//   );

//   if (!btn) return;

//   // Small delay to let Shopify AJAX finish
//   setTimeout(() => {
//     refreshCartDrawer();
//   }, 500);
// });

// Menu Current Item Selections
document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.pathname;

  document.querySelectorAll('.sub-category .top-menu a').forEach(link => {
    const linkUrl = new URL(link.href).pathname;

    if (currentUrl === linkUrl) {
      link.classList.add('active-item');
      
      // optional: add to parent <li>
      if (link.closest('li')) {
        link.closest('li').classList.add('active-parent');
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {

  // 👉 Handle ALL clicks safely (capture phase)
  document.addEventListener("click", function (e) {

    const toggle = e.target.closest("[data-toggle='collapse']");
    const link = e.target.closest(".top-menu a");

    // ============================
    // 👉 TOGGLE CLICK (OPEN/CLOSE)
    // ============================
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();

      const targetSelector = toggle.getAttribute("data-href") || toggle.getAttribute("href");
      const target = document.querySelector(targetSelector);

      if (!target) return;

      const parentLi = toggle.closest("li");

      // 🔥 Close sibling menus (IMPORTANT FIX)
      const siblings = parentLi.parentElement.children;

      Array.from(siblings).forEach(sib => {
        if (sib !== parentLi) {
          sib.querySelectorAll(".show").forEach(el => {
            el.classList.remove("show");
          });
        }
      });

      // 🔁 Toggle current menu
      target.classList.toggle("show");
      parentLi.classList.toggle("thisOne");

      return;
    }

    // ============================
    // 👉 REAL LINK CLICK
    // ============================
    if (link) {
      const href = link.getAttribute("href");

      if (href && href !== "#" && !link.hasAttribute("data-toggle")) {
        // 🚫 STOP collapse interference
        e.stopImmediatePropagation();

        // ✅ allow navigation normally
        return;
      }
    }

  }, true);


  // ============================
  // 👉 OPTIONAL: CLICK OUTSIDE CLOSE ALL
  // ============================
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".top-menu")) {
      document.querySelectorAll(".top-menu .show").forEach(el => {
        el.classList.remove("show");
      });
    }
  });

});

// Product Page Slider
document.addEventListener("DOMContentLoaded", function () {

  /* ---------------- THUMBS ---------------- */
  const thumbs = new Swiper(".thumb-sliders", {
    slidesPerView: 3,
    spaceBetween: 15,

    watchSlidesProgress: true,
    slideToClickedSlide: true,

    // ❌ IMPORTANT: no loop here
    loop: true,

    breakpoints: {
      768: {
        slidesPerView: 4
      },
      1024: {
        slidesPerView: 6
      }
    }
  });


  /* ---------------- MAIN ---------------- */
  const main = new Swiper(".main-slider", {
    spaceBetween: 35,
    speed: 600,

    // RTL support
    rtl: true,

    // ⚠️ safer to keep OFF to avoid bugs
    loop: false,

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },

    thumbs: {
      swiper: thumbs,
    }
  });
});

// Search For Disabled
// document.addEventListener("DOMContentLoaded", function () {
//     const input = document.querySelector('.mobilesearchArea input');
//     const button = document.querySelector('.mobilesearchArea .search-header__submit');

//     // Disable initially
//     button.disabled = true;

//     input.addEventListener("input", function () {
//         if (input.value.trim() !== "") {
//             button.disabled = false;
//         } else {
//             button.disabled = true;
//         }
//     });
// });

// Google Merchant
setInterval(() => {
    const widget = document.getElementById('google-merchantwidget-iframe-wrapper');
    if(widget){
        widget.style.setProperty('bottom', '60px', 'important');
        widget.style.setProperty('right', '-5px', 'important');
    }
}, 500);

// Filter Code
(function() {
  const TARGET_VALUE = "ordered_updated";

  // Core processing for a single input element
  function processInput(input) {
	if (!input || input._orderedUpdatedProcessed) return;
	if (input.value !== TARGET_VALUE) return;

	// Mark processed
	input._orderedUpdatedProcessed = true;

	// Always uncheck
	try { input.checked = false; } catch (e) {}

	// Prevent future changes (user or script) by forcing unchecked on change and click
	const forceUnchecked = (e) => {
	  if (input.checked) {
		try { input.checked = false; } catch (err) {}
	  }
	};
	input.addEventListener('change', forceUnchecked, { capture: true });
	input.addEventListener('click', forceUnchecked, { capture: true });

	// Hide the nearest li if found, otherwise hide the input and parent element
	const li = input.closest('li');
	if (li) {
	  // Prefer the CSS :has() (already applied). For older browsers, add a class fallback.
	  li.classList.add('hide-ordered-updated');
	} else {
	  // Fallback: hide parent element
	  const parent = input.parentElement;
	  if (parent) parent.style.display = 'none';
	  input.style.display = 'none';
	}
  }

  // Find existing inputs in both lists and process
  function scanAndProcess(root = document) {
	// Selector covers both desktop and mobile lists
	const selector = '.facets__list input[type="checkbox"], ul.mobile-facets__list.list-unstyled input[type="checkbox"], input[type="checkbox"][value="' + TARGET_VALUE + '"]';
	const inputs = root.querySelectorAll(selector);
	inputs.forEach(processInput);
  }

  // Run immediately (synchronous) to catch as early as possible
  try {
	scanAndProcess(document);
  } catch (e) {
	// ignore
  }

  // If DOM may not be ready yet and you inserted this inline in head, also run on DOMContentLoaded
  if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => scanAndProcess(document));
  }

  // Watch for dynamically added nodes (AJAX, client-side renders)
  const observer = new MutationObserver(mutations => {
	for (const m of mutations) {
	  // If nodes added, scan them; scanning the addedNodes subtree is efficient
	  if (m.addedNodes && m.addedNodes.length) {
		m.addedNodes.forEach(node => {
		  // Only elements have querySelectorAll
		  if (node.nodeType === 1) {
			scanAndProcess(node);
		  }
		});
	  }
	  // If attributes changed on existing nodes (rare), rescan target node
	  if (m.type === 'attributes' && m.target) {
		const t = m.target;
		if (t.matches && (t.matches('input[type="checkbox"]') || t.querySelector)) {
		  scanAndProcess(t);
		}
	  }
	}
  });

  observer.observe(document.documentElement || document, {
	childList: true,
	subtree: true,
	attributes: true,
	attributeFilter: ['value', 'class', 'checked']
  });

  // Optional: expose a stop function if needed later
  window.__stopOrderedUpdatedHide = function() {
	observer.disconnect();
  };
})();

// Cart Page loader
document.addEventListener('DOMContentLoaded', function () {
    const formsrec = document.querySelectorAll('.recommended-cart-form');
    formsrec.forEach(form => {
         const button = form.querySelector('.add-to-cart-btn-rec');
        // Remove loading on page load/back
        if (button) {
            button.classList.remove('loading');
        }
        form.addEventListener('submit', function () {
            if (button) {
                button.classList.add('loading');
            }
        });
        // Fix browser back button cache issue
        window.addEventListener('pageshow', function () {
            if (button) {
                button.classList.remove('loading');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const qvButton = document.getElementById('qv-add-to-cart');
    if (qvButton) {
        // Remove loading class on page load/back
        qvButton.classList.remove('loading');
        qvButton.addEventListener('click', function () {
            qvButton.classList.add('loading');
        });
        // Fix browser back button cache issue
        window.addEventListener('pageshow', function () {
            qvButton.classList.remove('loading');
        });
   }
});

document.addEventListener('DOMContentLoaded', function () {
    const checkoutBtn = document.querySelector('.checkBtn');
    // Remove loading when page loads/reloads/back
    if (checkoutBtn) {
        checkoutBtn.classList.remove('loading');
        checkoutBtn.addEventListener('click', function () {
            this.classList.add('loading');
        });
    }
    // Fix browser back button cache issue
    window.addEventListener('pageshow', function () {
        if (checkoutBtn) {
            checkoutBtn.classList.remove('loading');
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const cartBtnbv = document.querySelector('.cartBtnb');
    // Remove loading when page loads/reloads/back
    if (cartBtnbv) {
        cartBtnbv.classList.remove('loading');
        cartBtnbv.addEventListener('click', function () {
            this.classList.add('loading');
        });
    }
    // Fix browser back button cache issue
    window.addEventListener('pageshow', function () {
        if (cartBtnbv) {
            cartBtnbv.classList.remove('loading');
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {

  function initFacetAccordion() {
    const summaries = document.querySelectorAll(
      "#FacetFiltersFormSidebar .facets__summary"
    );

    const displays = document.querySelectorAll(
      "#FacetFiltersFormSidebar .facets__displays"
    );

    if (!summaries.length) return;

    /*
     * Remove old state
     */
    displays.forEach(function (display) {
      display.classList.remove("is-open");
    });

    /*
     * Open first filter by default
     */
    const firstDisplay = summaries[0]
      ?.closest(".facets__disclosure")
      ?.querySelector(".facets__displays");

    if (firstDisplay) {
      firstDisplay.classList.add("is-open");
    }
  }


  /*
   * Use EVENT DELEGATION.
   *
   * This is important because Shopify replaces
   * the filter HTML after selecting a checkbox.
   */
  document.addEventListener("click", function (event) {

    const summary = event.target.closest(
      "#FacetFiltersFormSidebar .facets__summary"
    );

    if (!summary) return;

    const disclosure = summary.closest(".facets__disclosure");

    if (!disclosure) return;

    const currentDisplay = disclosure.querySelector(".facets__displays");

    if (!currentDisplay) return;

    /*
     * Close other filters
     */
    document
      .querySelectorAll(
        "#FacetFiltersFormSidebar .facets__displays"
      )
      .forEach(function (display) {

        if (display !== currentDisplay) {
          display.classList.remove("is-open");
        }

      });

    /*
     * Toggle clicked filter
     */
    currentDisplay.classList.toggle("is-open");

  });


  /*
   * Checkbox handling
   *
   * Do NOT prevent the default checkbox behavior.
   * Shopify needs the checkbox event to update the filters.
   */
  document.addEventListener("change", function (event) {

    const checkbox = event.target.closest(
      "#FacetFiltersFormSidebar input[type='checkbox']"
    );

    if (!checkbox) return;

    /*
     * Remember which filter was selected.
     */
    const disclosure = checkbox.closest(".facets__disclosure");

    if (disclosure) {
      sessionStorage.setItem(
        "activeFacetFilter",
        disclosure.getAttribute("data-index") || ""
      );
    }

  });


  /*
   * After Shopify AJAX updates/replaces the filters,
   * restore the selected filter accordion.
   */
  function restoreFacetAfterUpdate() {

    setTimeout(function () {

      const activeIndex = sessionStorage.getItem(
        "activeFacetFilter"
      );

      if (activeIndex) {

        const disclosure = document.querySelector(
          '#FacetFiltersFormSidebar .facets__disclosure[data-index="' +
          activeIndex +
          '"]'
        );

        if (disclosure) {

          document
            .querySelectorAll(
              "#FacetFiltersFormSidebar .facets__displays"
            )
            .forEach(function (display) {
              display.classList.remove("is-open");
            });

          const display = disclosure.querySelector(
            ".facets__displays"
          );

          if (display) {
            display.classList.add("is-open");
          }

        }

      } else {

        initFacetAccordion();

      }

    }, 100);

  }


  /*
   * Detect Shopify replacing the filter HTML.
   */
  const observer = new MutationObserver(function (mutations) {

    let filterChanged = false;

    mutations.forEach(function (mutation) {

      mutation.addedNodes.forEach(function (node) {

        if (
          node.nodeType === 1 &&
          (
            node.matches?.("#FacetFiltersFormSidebar") ||
            node.querySelector?.("#FacetFiltersFormSidebar") ||
            node.matches?.(".facets__disclosure") ||
            node.querySelector?.(".facets__disclosure")
          )
        ) {
          filterChanged = true;
        }

      });

    });

    if (filterChanged) {
      restoreFacetAfterUpdate();
    }

  });


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


  /*
   * Clear All button
   */
  function updateClearAll() {

    const checked = document.querySelectorAll(
      "#FacetFiltersFormSidebar input[type='checkbox']:checked"
    );

    const clearAll = document.querySelector(
      "#FacetFiltersFormSidebar .clear-all"
    );

    if (!clearAll) return;

    clearAll.style.display =
      checked.length > 0 ? "inline-block" : "none";
  }


  /*
   * Checkbox changes
   */
  document.addEventListener("change", function (event) {

    if (
      event.target.matches(
        "#FacetFiltersFormSidebar input[type='checkbox']"
      )
    ) {
      updateClearAll();
    }

  });


  /*
   * Initial setup
   */
  initFacetAccordion();
  updateClearAll();

});